angular.module('vastdesk').controller('ModifierFormController', ['$scope', '$rootScope', '$interval', function($scope, $rootScope, $interval) {
  var demandPartnerDomIds = "#bid_modifier_demand_partner_id, #delivery_modifier_demand_partner_id";

  var demandPartnerSelect = $(demandPartnerDomIds);
  $scope.demandPartnerId = demandPartnerSelect.val();

  var setDemandPartnerContentVisibility = function() {
    $('.demand-partner-hidden').toggleClass('hidden', !!$scope.demandPartnerId);
    $('.demand-partner-shown').toggleClass('hidden', !$scope.demandPartnerId);
  };

  var changeDemandPartner = function() {
    $scope.demandPartnerId = $(demandPartnerDomIds).val();
    setDemandPartnerContentVisibility();
    clearAllListSelections();
    $rootScope.$broadcast('demandPartnerIdChange', { demandPartnerId: $scope.demandPartnerId });
  };

  var clearAllListSelections = function() {
    $('.modifier-list-ids select[data-tom-select]').each(function() {
      var tomSelect = this.tomselect;
      if (tomSelect) {
        tomSelect.clear();
      }
    });
  };

  setDemandPartnerContentVisibility();

  var intervalId = $interval(function() {
    var demandPartnerSelect = $(demandPartnerDomIds);
    if (demandPartnerSelect[0] && demandPartnerSelect[0].tomselect) {
      $interval.cancel(intervalId);
      demandPartnerSelect[0].tomselect.on('change', function() { changeDemandPartner(); });
    } else if ($scope.demandPartnerId) {
      // Demand partner is set but is readonly
      $interval.cancel(intervalId);
    }
  }, 1);
}]);
